module.exports = "<div class=\"container\" style=\"margin-top: 30px\">\n  <div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n      <h3 class=\"panel-title\">\n        配置生成\n      </h3>\n    </div>\n    <div class=\"panel-body\">\n      <div ui-view></div>\n    </div>\n  </div>\n</div>\n\n\n"


/*****************
 ** WEBPACK FOOTER
 ** ./examples/generateconfig/template.html
 ** module id = 249
 ** module chunks = 0
 **/